import { channel, SystemType, Vehicle } from "@tm/models"

export default function getVehicle(vehicle?: Vehicle, systemType?: SystemType) {
    if (!vehicle && systemType === SystemType.Redesign) {
        return channel("WORKTASK", "FAKE_WORKTASK").last(1, "VEHICLE/LOADED").first()?.content
    }
    return vehicle
}
